import { useQueries } from '@tanstack/react-query';

import { useBevoegdGezag } from '../bevoegdGezag';

const activeFilter = [
  {
    model: 'BevoegdGezag',
    field: 'Volgend',
    op: 'is_null',
    value: '',
  },
  {
    field: 'Stop_Lineage',
    op: 'eq',
    value: '0',
  },
] as const;

/**
 * Landelijk bevoegde gezagen are not owned by a tenant,
 * so they are fetched separately and merged in the results.
 */
const useActiveBevoegdGezagList = () =>
  useQueries({
    queries: [
      useBevoegdGezag.getOptions({
        page: 1,
        size: 1000,
        filter: [...activeFilter, { field: 'Landelijk', op: 'eq', value: '1' }],
        sort: [{ field: 'Naam', direction: 'asc' }],
      }),
      useBevoegdGezag.getOptions({
        page: 1,
        size: 1000,
        filter: [
          ...activeFilter,
          {
            model: 'BevoegdGezagLineage',
            field: 'organization',
            op: 'eq',
            value: '',
          },
        ],
        sort: [{ field: 'Naam', direction: 'asc' }],
      }),
    ],
    combine: (responses) => {
      const objectsById = new Map(
        responses
          .flatMap((response) => response.data?.objects ?? [])
          .map((bevoegdGezag) => [bevoegdGezag.ID, bevoegdGezag])
      );

      return {
        isLoading: responses.some((response) => response.isLoading),
        isSuccess: responses.every((response) => response.isSuccess),
        data: { objects: Array.from(objectsById.values()) },
      };
    },
  });

export { useActiveBevoegdGezagList };
